import type { SchemaField } from '@cli-types/core-engine/schema.js'

export function ensureSchemaChildFields(field: SchemaField): SchemaField[] {
  if (!Array.isArray(field.fields)) {
    field.fields = []
  }
  return field.fields
}
